export const greenInitiativeLink = ' https://m-phar.com/green-initiative/';
